// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--szVNT";
export var btnBlock = "banner-module--btnBlock--z4sKo";
export var container = "banner-module--container--ejEIT";
export var hideMobBlock = "banner-module--hideMobBlock--R5qt1";
export var img = "banner-module--img--vr24g";
export var indexPkw = "banner-module--indexPkw--D+FDg";
export var mobBtn = "banner-module--mobBtn--hEbOU";
export var secondContainer = "banner-module--secondContainer--ikd13";
export var section = "banner-module--section--mPyfo";
export var text = "banner-module--text--VSXqz";